import React, { Component } from 'react';
import Chart from "react-apexcharts";
import moment from 'moment';

class BarchartVip extends Component {
    constructor(props) {
        super(props);

        const breachesData = props?.total?.map(item => item?.totalBreaches);
        const darkWebData = props?.total?.map(item => item?.totalDarkWebMentions);
        const socialMediaData = props?.total?.map(item => item?.totalSocialMediaImpersonations);
        const personalInformation = props?.total?.map(item => item?.totalPersonalInformationBreaches);

        this.state = {
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        columnWidth: "40%",
                        borderRadius: 5
                    },
                },
                fill: {
                    colors: ['#1DBF73', '#FF9F0A', '#D44226', '#FB3B52']
                },
                colors: ['#1DBF73', '#FF9F0A', '#D44226', '#FB3B52'],
                legend: {
                    position: 'top',
                    horizontalAlign: 'left'
                },
                xaxis: {
                    axisTicks: { show: false },
                    axisBorder: { show: false },
                    categories: props.dates.map((date) => moment(date).format('DD-MM-YYYY')),
                },
                yaxis: {
                    title: {
                        text: 'Records Found'
                    }
                }
            },
            series: [
                {
                    name: "Breaches",
                    data: breachesData
                },
                {
                    name: "Dark Web Mentions",
                    data: darkWebData
                },
                {
                    name: "Social Media Impersonations",
                    data: socialMediaData
                },
                {
                    name: "Personal Information",
                    data: personalInformation
                }
            ]
        };
    }

    render() {
        return (
            <div>
                <Chart
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    className="chart-class"
                    height="350"
                />
            </div>
        );
    }
}

export default BarchartVip;
